import React from 'react';
import './Button.css';

const Button = ({
  children,
  className = '',
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  icon = null,
  iconPosition = 'left',
  type = 'button',
  ...props
}) => {
  const classes = [
    'ui-button',
    `ui-button-${variant}`,
    `ui-button-${size}`,
    fullWidth ? 'ui-button-full' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} {...props}>
      {icon && iconPosition === 'left' && <span className="ui-button-icon">{icon}</span>}
      <span className="ui-button-content">{children}</span>
      {icon && iconPosition === 'right' && <span className="ui-button-icon">{icon}</span>}
    </button>
  );
};

export default Button;
